import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import type { Selection } from '@atlaskit/editor-prosemirror/state';
import type { Command } from '@atlaskit/editor-common/types';

export const setSelection =
	(selection?: Selection): Command =>
	(state, dispatch) => {
		if (!dispatch) {
			return false;
		}

		const emptySelection = TextSelection.create(state.doc, 0);
		const tr = state.tr.setSelection(selection ?? emptySelection);

		dispatch(tr);
		return true;
	};
